import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../common/routesUtils";
import { TransportPerspectiveSelector } from "../../../components/common/TransportPerspectiveSelector";
import { View } from "../../../components/layout/View";
import { PageType } from "../../../config/page.types";
import { useBreadcrumbs } from "../../../context/BreadcrumbsProvider";
import { useFiltersRegistry } from "../../../context/FiltersProvider";
import { useNavigationPreferences } from "../../../hooks/usePreferences";
import { useTransportFilterContext } from "../../../hooks/useTransportFilterContext ";
import { UserPeriodFilter } from "../../../state/company";
import { rootCauseCards, RootCauseCardType } from "./data";
import { RootCauseCard } from "./RootCauseCard";

export type RootCauseWorkspaceType = "baseline" | "comparison";

export const isRootCauseWorkspace = (value: RootCauseCardType): value is RootCauseWorkspaceType => {
	return value === "baseline" || value === "comparison";
};

export const RootCause = () => {
	const { navigationPreferences } = useNavigationPreferences();
	const { visitPage } = useBreadcrumbs();
	const navigate = useNavigate();

	const { rootCauseState, updateRootCausePeriod, isRootCauseAnalysisEnabled, prepareRootCausePayload } =
		useFiltersRegistry();

	const filterContext = useTransportFilterContext(navigationPreferences.transportsPerspective);

	const runAnalysis = () => {
		const perspective = navigationPreferences.transportsPerspective;

		const isReady = prepareRootCausePayload(perspective);

		if (!isReady) {
			return;
		}

		visitPage(PageType.WhatIfRootCauseResults, false);
		navigate(AppRoutes.WhatIfRootCauseResults);
	};

	return (
		<View
			pageType={PageType.WhatIfRootCause}
			headerContext={{
				runAnalysis,
				disabled: !isRootCauseAnalysisEnabled,
			}}
		>
			<Stack direction="row-reverse">
				<TransportPerspectiveSelector />
			</Stack>
			<Stack direction="column" spacing={2} marginTop={2}>
				{rootCauseCards.map((card) => {
					// if is baseline or comparision
					if (isRootCauseWorkspace(card.id)) {
						const workspace = card.id;

						return (
							<RootCauseCard
								key={card.id}
								id={card.id}
								filterContext={filterContext}
								availableActions={card.availableActions}
								periodFilter={rootCauseState.periods[workspace]}
								setPeriodFilter={(filter: UserPeriodFilter) => updateRootCausePeriod(workspace, filter)}
							/>
						);
					}

					// if is perimeter
					return (
						<RootCauseCard
							key={card.id}
							id={card.id}
							filterContext={filterContext}
							availableActions={card.availableActions}
						/>
					);
				})}
			</Stack>
		</View>
	);
};
